module.exports = __webpack_public_path__ + "static/media/Comprehensive-Guide-to-Cash-Used-Cars-in-Beenleigh-4207.927b0211.jpg";